import React, { Fragment } from 'react';
import { Column, Title, Button } from "rbx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import '../../../styles/footer.scss';

function Footer(){
    return(
        <Fragment>
            <Column.Group className="footer" centered textAlign="centered">
                <Column>
                    <Button color={'success'}>                         
                        <a href="tel:0800 601 4031">
                            <FontAwesomeIcon icon={ faPhone }/>
                            &nbsp;0800 601 4031
                        </a>                        
                    </Button>
                    &nbsp; 
                    <Button color={'success'}>
                        <a href="https://api.whatsapp.com/send/?phone=558006014031&text&app_absent=0"> 
                            <FontAwesomeIcon icon={ faWhatsapp }/>                            
                            &nbsp;Chama no Whats
                        </a>
                    </Button>
                    <Title size={7} className="has-text-grey copy">
                        Copyright © 2021 Universidade Paranaense - Todos os Direitos Reservados
                    </Title>
                </Column>
            </Column.Group>
        </Fragment>
    )
};
  
export default Footer;